import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { BettingCreateRequest, BettingEventDto } from '@playball/common/dto/Betting';
import { DataResponse } from '@playball/common/dto/Common';

const BettingCreatePage: React.FC = () => {
    const navigate = useNavigate();
    const { fetchApi, user } = useAuth();
    const [title, setTitle] = useState<string>('');
    const [optionA, setOptionA] = useState<string>('');
    const [optionB, setOptionB] = useState<string>('');
    const [price, setPrice] = useState<number>(10);
    const [commissionRate, setCommissionRate] = useState<number>(10);
    const [startAt, setStartAt] = useState<string>('');
    const [endAt, setEndAt] = useState<string>('');
    const [loading, setLoading] = useState<boolean>(false);

    useEffect(() => {
        if (user && !user.is_admin) {
            navigate('/betting');
        }
    }, [user, navigate]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);

        if (new Date(startAt) >= new Date(endAt)) {
            alert('종료 시간은 시작 시간보다 이후여야 합니다.');
            setLoading(false);
            return;
        }

        try {
            const newBettingEvent: BettingCreateRequest = {
                title,
                option_a: optionA,
                option_b: optionB,
                price,
                commission_rate: commissionRate,
                start_at: new Date(startAt).toISOString(),
                end_at: new Date(endAt).toISOString(),
            };

            const res: DataResponse<BettingEventDto> = await fetchApi('/api/betting', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(newBettingEvent),
            });
            if (!res.data) {
                throw new Error('베팅 이벤트 생성에 실패했습니다.');
            }
            alert('베팅 이벤트가 성공적으로 생성되었습니다!');
            navigate(`/betting/${res.data.id}`); // 생성된 이벤트 상세 페이지로 이동
        } catch (e: any) {
            alert(e.message);
        } finally {
            setLoading(false);
        }
    };

    return (
        <>
            <section className="guide-hero-section py-5">
                <div className="container text-center">
                    <h1 className="display-5 fw-bold">새 베팅 이벤트 생성</h1>
                </div>
            </section>    
            <div className="container mt-4">
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label htmlFor="title" className="form-label">제목</label>
                        <input
                            type="text"
                            className="form-control"
                            id="title"
                            value={title}
                            onChange={(e) => setTitle(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="optionA" className="form-label">옵션 A</label>
                        <input
                            type="text"
                            className="form-control"
                            id="optionA"
                            value={optionA}
                            onChange={(e) => setOptionA(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="optionB" className="form-label">옵션 B</label>
                        <input
                            type="text"
                            className="form-control"
                            id="optionB"
                            value={optionB}
                            onChange={(e) => setOptionB(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="price" className="form-label">참가비</label>
                        <input
                            type="number"
                            className="form-control"
                            id="price"
                            value={price}
                            onChange={(e) => setPrice(Number(e.target.value))}
                            required
                            min="0"
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="commissionRate" className="form-label">수수료율 (%)</label>
                        <input
                            type="number"
                            className="form-control"
                            id="commissionRate"
                            value={commissionRate}
                            onChange={(e) => setCommissionRate(Number(e.target.value))}
                            required
                            min="0"
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="startAt" className="form-label">시작 시간</label>
                        <input
                            type="datetime-local"
                            className="form-control"
                            id="startAt"
                            value={startAt}
                            onChange={(e) => setStartAt(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label htmlFor="endAt" className="form-label">종료 시간</label>
                        <input
                            type="datetime-local"
                            className="form-control"
                            id="endAt"
                            value={endAt}
                            onChange={(e) => setEndAt(e.target.value)}
                            required
                        />
                    </div>
                    <button type="submit" className="btn btn-primary" disabled={loading}>
                        {loading ? '생성 중...' : '이벤트 생성'}
                    </button>
                    <button type="button" className="btn btn-secondary ms-2" onClick={() => navigate('/betting')}>취소</button>
                </form>
            </div>
        </>
    );
};

export default BettingCreatePage;